import React from 'react';
import LinearText from '../../linear-text/linear-text';
import LinearImage from '../../linear-image/linear-image';
import {twMerge} from 'tailwind-merge';

interface OrganizationsProps {
    titleStyle?: string;
}
const Organizations: React.FC<OrganizationsProps> = ({titleStyle}) => {
    const titleStyleCombine = twMerge(
        'font-montserrat lg:!text-[34px] md:!text-[24px] text-[14px] font-bold bg-[linear-gradient(103.84deg,#7DFFF0_38.17%,#FF8DE6_70.98%,#FF398C_81.34%)]',
        titleStyle,
    );
    return (
        <div className="flex justify-center items-center gap-4 md:gap-16">
            <div className="flex flex-col justify-center items-center gap-2">
                <LinearText as={'h3'} className={titleStyleCombine}>
                    ĐƠN VỊ TỔ CHỨC
                </LinearText>
                <div>
                    <div className="md:!w-[320px] md:!h-[80px] sm:!w-[175px] sm:!h-[50px] w-[120px] h-[50px]">
                        <LinearImage
                            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/o-kids.png"
                            alt="Kidsplaza Logo"
                            width={320}
                            height={80}
                            className="md:!rounded-[15px] h-full rounded-[5px]"
                            imageClassName="object-contain md:!rounded-[15px] rounded-[5px]"
                            imageContainerClassName="md:!rounded-[15px] rounded-[5px]"
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-between items-center gap-2">
                <LinearText as={'h3'} className={titleStyleCombine}>
                    ĐƠN VỊ ĐỒNG HÀNH
                </LinearText>
                <div className="flex justify-center items-center gap-4">
                    <div className="lg:!w-[202px] lg:!h-[80px] md:!w-[175px] md:!h-[80px] xs:!w-[120px] w-[80px] h-[50px]">
                        <LinearImage
                            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/o-abbott.png"
                            alt="Abbott Logo"
                            width={202}
                            height={80}
                            className="object-cover h-full md:!rounded-[15px] rounded-[5px]"
                            imageClassName=" object-contain md:!rounded-[15px] rounded-[5px]"
                            imageContainerClassName="md:!rounded-[15px] rounded-[5px]"
                        />
                    </div>
                    <div className="lg:!w-[202px] lg:!h-[80px] md:!w-[175px] md:!h-[80px] xs:!w-[120px] w-[80px] h-[50px]">
                        <LinearImage
                            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/o-moyuum.png"
                            alt="Moyuum Logo"
                            width={202}
                            height={80}
                            className="h-full sm:h-auto md:!rounded-[15px] rounded-[5px]"
                            imageClassName="object-contain md:!rounded-[15px] rounded-[5px]"
                            imageContainerClassName="md:!rounded-[15px] rounded-[5px]"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Organizations;
